import { createSlice } from '@reduxjs/toolkit';

const whatsappCampaignSlice = createSlice({
	name: 'whatsappCampaigns',
	initialState: {
		list: [], // [{ id, status, total, sent, failed, failedNumbers, percentage, startedAt }]
	},
	reducers: {
		addCampaign: (state, { payload }) => {
			const newCampaign = {
				id: payload.campaignId,
				status: 'running',
				total: payload?.total || 0,
				sent: 0,
				failed: 0,
				failedNumbers: [],
				percentage: 0,
				startedAt: new Date().toISOString(),
			};

			state.list.push(newCampaign);

			console.log('added campaign:', newCampaign);
		},

		updateCampaign: (state, { payload }) => {
			console.log('UPDATE CAMPAIGN:', payload);
			const campaign = state.list.find((c) => c.id === payload.campaignId);
			if (campaign) Object.assign(campaign, payload);
		},
		removeCampaign: (state, { payload }) => {
			state.list = state.list.filter((c) => c.id !== payload);
		},
	},
});

export const { addCampaign, updateCampaign, removeCampaign } =
	whatsappCampaignSlice.actions;

// Selectors
export const selectAllCampaigns = (state) =>
	state.whatsappCampaigns?.list || [];
export const selectRunningCampaigns = (state) =>
	state.whatsappCampaigns?.list?.filter((c) => c.status === 'running') || [];

export default whatsappCampaignSlice.reducer;